import { render, staticRenderFns } from "./memberData.vue?vue&type=template&id=f22926c2&scoped=true&"
import script from "./memberData.vue?vue&type=script&lang=js&"
export * from "./memberData.vue?vue&type=script&lang=js&"
import style0 from "./memberData.vue?vue&type=style&index=0&id=f22926c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22926c2",
  null
  
)

export default component.exports